import { Outlet } from "react-router";

export const handle = { forceTheme: "dark" };

export default function Conf() {
  return <Outlet />;
}
